export default __webpack_public_path__ + "static/media/cloudezsmtp.cb12a6e5.svg";